export default __webpack_public_path__ + "static/media/jade-caret-up.d9d8b477.svg";